export default __webpack_public_path__ + "static/media/parking.inline.b159b328.svg";